<template>
  <hm-content title="">
    <div class="hm-home">
      <el-card>
        <div class="hm-headline">
          <span class="subhead">
            <strong>{{ ruleName }}</strong
            >使用详情
          </span>
        </div>
        <div class="p10">
          <div class="flex flex-between">
            <div class="flex table-panel">
              <span
                class="btn"
                :class="{ active: v.status === activeTab }"
                @click="switchTab(v.status)"
                v-for="(v, i) in btnList"
                :key="i"
                v-show="v.show"
                >{{ v.name }}&nbsp;({{ v.count }})</span
              >
            </div>
            <div>
              <el-input
                clearable
                v-model.trim="keywords"
                placeholder="输入手机号/微信编码/券号"
                size="small"
                class="mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
              <el-button
                size="small"
                type="success"
                @click="output"
                :loading="isLoading"
                >导出</el-button
              >
            </div>
          </div>
          <div class="send-table">
            <el-table border :data="detail" style="width: 100%" id="table" @sort-change="sortChange">
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderName"
                label="导购名"
                v-if="isSendToGuider"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeOutletName"
                label="导购归属门店"
                v-if="isSendToGuider"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberName"
                label="用户名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberMobile"
                label="手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="userName"
                label="微信编码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="线下会员卡号"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="openUserProfile(scope.row.offlineVipId)"
                    >{{ scope.row.offlineVipNo }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="couponCode"
                label="券码"
              ></el-table-column>
              <!-- <el-table-column header-align="center" align="center" prop="isVerification" label="是否核销">
              </el-table-column>-->
              <el-table-column
                header-align="center"
                align="center"
                label="使用订单"
                prop="toOrder"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="status"
                label="券状态"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTimeFormat"
                label="发放时间"
                sortable
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="useDate"
                label="使用时间"
                v-if="activeTab === 2"
              ></el-table-column>
              <el-table-column
                v-if="activeTab === 2"
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    v-if="scope.row.orderOnlineId"
                    @click="viewOrder('online', scope.row)"
                    >线上订单详情</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    v-if="scope.row.orderOfflineId"
                    @click="viewOrder('offline', scope.row)"
                    >线下订单详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="text-center">
          <el-pagination
            background
            layout="total,sizes,  prev, pager, next, jumper"
            :total="detailTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </el-card>
      <el-dialog
        title="线下订单详情"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="600px"
      >
        <el-scrollbar :vertical="false" wrap-style="height: 300px;">
          <div class="mb20">
            会员：{{ currentRow.memberName }} 消费：<span class="primary"
              >￥{{ currentRow.totPrice }}</span
            >
          </div>
          <div class="dialog-body">
            <div class="mb20">
              <div class="table-panel title">商品信息</div>
              <div class="table">
                <el-table
                  stripe
                  border
                  :data="orderDetail"
                  style="width: 100%"
                  id="table"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    prop="spu_name"
                    align="center"
                    label="商品名"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="市场价"
                  >
                    <template slot-scope="scope">
                      <span class="primary">￥{{ scope.row.market_price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="门店价"
                  >
                    <template slot-scope="scope">
                      <span class="primary">￥{{ scope.row.shop_price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="goods_number"
                    align="center"
                    label="商品数量"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div v-if="couponInfo.length">
              <div class="table-panel title">购买后已发放优惠券</div>
              <div class="table">
                <el-table
                  stripe
                  border
                  :data="couponInfo"
                  style="width: 100%"
                  id="table"
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    prop="name"
                    align="center"
                    label="优惠券名"
                  />
                  <el-table-column
                    header-align="center"
                    prop="sendName"
                    align="center"
                    label="发放规则名"
                  />
                  <el-table-column
                    header-align="center"
                    prop="toOrder"
                    align="center"
                    label="已使用订单号"
                  />
                  <el-table-column
                    header-align="center"
                    prop="couponCode"
                    align="center"
                    label="优惠券码"
                  />
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="优惠券状态"
                  >
                    <template slot-scope="scope">
                      <span class="primary" v-if="scope.row.couponStatus === 2"
                        >已使用</span
                      >
                      <span class="primary" v-if="scope.row.couponStatus === 4"
                        >未使用</span
                      >
                      <span class="primary" v-if="scope.row.couponStatus === 5"
                        >冻结</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="dialogVisible = false" size="small">关闭</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="onlineDialogVisible"
        width="1200px"
      >
        <div slot="title">
          <span class="mr10">订单详情</span>
          <span class="form-item-tip" style="color: #fF0000"
            >当前订单状态：{{ orderSta }}</span
          >
        </div>
        <div class="content">
          <ul class="info-list mt10">
            <li>
              <div class="flex flex-between">
                <div class="flex flex-wrap">
                  <div class="title mr10">基本信息</div>
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="orderDetails.isOverseas === 'yes'"
                    >海外购</el-tag
                  >
                </div>
              </div>

              <div class="mb20">
                <el-table stripe border :data="[orderDetails]" size="small">
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiptSn"
                    label="订单信息"
                  >
                    <template slot-scope="scope">
                      <div class="text-left">
                        <el-tag
                          size="mini"
                          effect="plain"
                          color="#FFEEF6"
                          v-if="scope.row.orderType === 'integral_order'"
                          >积分兑换订单</el-tag
                        >
                        <div>订单号：{{ scope.row.receiptSn }}</div>
                        <div>
                          是否拆单发货：{{
                            scope.row.packageNum > 1 ? "是" : "否"
                          }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="shareMemberName"
                    label="推荐关系"
                  >
                    <template slot-scope="scope">
                      <div class="text-left">
                        <div>
                          推荐类型：{{
                            scope.row.shareMemberName !== null &&
                            scope.row.platformId !== "smg"
                              ? "分销"
                              : ""
                          }}
                        </div>
                        <div>
                          分销会员：{{ scope.row.shareMemberName }}/{{
                            scope.row.shareMemberMobile
                          }}
                        </div>
                        <div>所属机构：{{ scope.row.departName }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiptSn"
                    label="订单主体"
                  >
                    <template slot-scope="scope">
                      <div class="text-left">
                        <div>下单会员：{{ scope.row.memberName }}</div>
                        <div>
                          收货人：{{ scope.row.receiverName }}/{{
                            scope.row.receiverMobile
                          }}
                        </div>
                        <div>
                          收货地址：{{ scope.row.deliveryProvince
                          }}{{ scope.row.deliveryAddress }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="receiptSn"
                    label="费用信息"
                  >
                    <template slot-scope="scope">
                      <div class="text-left">
                        <div>商品合计金额：+{{ scope.row.totalPrice }}</div>
                        <div v-if="scope.row.orderType === 'integral_order'">
                          积 分：+{{ scope.row.integralPoint }}
                        </div>
                        <div>优 惠 券：-{{ scope.row.couponMoney }}</div>
                        <div>优惠券信息：{{ scope.row.couponName }}</div>
                        <div>活 动：-{{ scope.row.activeMoney }}</div>
                        <div v-if="scope.row.isOverseas === 'yes'">
                          税 费：+{{ scope.row.taxFee }}
                        </div>
                        <div>运 费：+{{ scope.row.deliverMoney }}</div>
                        <div v-if="scope.row.deliverCouponMoney">
                          运费券：-{{ scope.row.deliverCouponMoney }}
                        </div>
                        <div class="flex flex-between">
                          <div>储 值 卡：-{{ scope.row.prepayMoney }}</div>
                          <div
                            style="fontWeight:600"
                            v-if="orderDetails.payMode !== 'no_pay'"
                          >
                            <div v-if="scope.row.orderType === 'integral_order'">
                              实付款:<span v-if="scope.row.actuallyPrice"
                                >￥{{ scope.row.actuallyPrice }}+</span
                              >
                              {{ scope.row.integralPoint }}积分
                            </div>
                            <div v-else>
                              实付款：{{ scope.row.actuallyPrice }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </li>
            <li class="mb20">
              <div class="flex flex-between">
                <div class="title">
                  商品信息
                </div>
              </div>

              <el-table
                border
                :data="orderGoods"
                :span-method="objectSpanMethod"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsImg"
                  label="商品图片"
                >
                  <template slot-scope="scope">
                    <div>
                      <div
                        class="flex flex-center item-center"
                        v-if="scope.row.returnType !== 'no'"
                      >
                        <!-- 仅退款 -->
                        <img
                          v-if="scope.row.refundReturnType === 'money'"
                          style="width:100px;height:100px"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                          alt=""
                        />

                        <!-- 退货退款 -->
                        <img
                          v-if="scope.row.refundReturnType === 'refund'"
                          style="width:100px;height:100px"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                          alt=""
                        />

                        <!-- 退运费 -->
                        <img
                          v-if="scope.row.refundReturnType === 'deliver'"
                          style="width:100px;height:100px"
                          src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                          alt=""
                        />
                      </div>

                      <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'yes'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                        alt=""
                      />
                      <img
                        class="warning-tuikuan"
                        v-show="scope.row.returnType === 'doing'"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                        alt=""
                      />
                      <div
                        class="flex flex-center item-center"
                        :class="
                          scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                        "
                      >
                        <div>
                          <img
                            style="width:100px;height:100px;"
                            v-if="scope.row.goodsImg"
                            :src="scope.row.goodsImg"
                            alt=""
                          />
                          <div style="width:100%">
                            <el-tag
                              style="width:100%"
                              size="mini"
                              effect="plain"
                              type="success"
                              v-if="scope.row.isGift === 'gift'"
                              >赠 品</el-tag
                            >
                            <el-tag
                              style="width:100%"
                              size="mini"
                              effect="dark"
                              type="success"
                              v-else-if="scope.row.isGift === 'markup'"
                              >加价购商品</el-tag
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="商品名称/品牌"
                  width="200"
                >
                  <template slot-scope="scope">
                    <p>{{ scope.row.spuName }}</p>
                    <p>品牌: {{ scope.row.brandName }}</p>
                    <el-tag type="warning"
                      >{{
                        scope.row.spuType === "virtual" ? "虚拟" : "实物"
                      }}商品</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="价格/货号"
                >
                  <template slot-scope="scope">
                    <p>价格: {{ scope.row.totalPrice }}</p>
                    <p>货号: {{ scope.row.goodsSn }}</p>
                    <p>条码: {{ scope.row.barCode }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="净重/毛重"
                >
                  <template slot-scope="scope">
                    <p v-if="scope.row.netWeight">
                      净重: {{ scope.row.netWeight }}
                    </p>
                    <p v-if="scope.row.grossWeight">
                      毛重: {{ scope.row.grossWeight }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="specIdGroupName"
                  label="规格"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNum"
                  label="数量"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalPrice"
                  label="小计金额"
                >
                  <template slot-scope="scope">
                    <p>
                      {{ scope.row.payPrice * scope.row.goodsNum }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="
                        orderDetails.payMode !== 'no_pay' &&
                          isBtn('tuikuan:false')
                      "
                    >
                      <el-button
                        v-if="
                          (scope.row.spuType === 'virtual' &&
                            scope.row.memberLaunchRefund === 'yes') ||
                            scope.row.spuType !== 'virtual'
                        "
                        :disabled="scope.row.returnType !== 'no'"
                        size="small"
                        class="danger"
                        type="text"
                        @click="refund(scope.row)"
                        >退款</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  prop="expressQueryId"
                  label="包裹信息"
                  width="220"
                >
                  <template slot-scope="scope">
                    <div>
                      <div>
                        <el-tag
                          size="mini"
                          effect="plain"
                          color="#FFEEF6"
                          v-if="scope.row.expressState === 'waitAllocation'"
                          >待配货</el-tag
                        >
                        <el-tag
                          size="mini"
                          effect="plain"
                          color="#FFEEF6"
                          v-if="scope.row.expressState === 'waitDeliver'"
                          >待发货</el-tag
                        >
                        <el-tag
                          size="mini"
                          effect="plain"
                          color="#FFEEF6"
                          v-if="scope.row.expressState === 'alreadyDeliver'"
                          >已发货</el-tag
                        >
                        <el-tag
                          size="mini"
                          effect="plain"
                          color="#FFEEF6"
                          v-if="!!scope.row.supplierId"
                          >三方</el-tag
                        >
                        <el-tag size="mini" effect="plain" color="#FFEEF6" v-else
                          >自营</el-tag
                        >
                      </div>
                      <div>发货单号:{{ scope.row.deliverSn }}</div>
                      <div>快递单号:{{ scope.row.expressOrderSn }}</div>
                      <div
                        class="mb10"
                        v-if="scope.row.expressState === 'alreadyDeliver'"
                      >
                        发货门店：{{ scope.row.sendShopName }}
                      </div>
                      <div v-if="scope.row.expressState === 'alreadyDeliver'">
                        发货时间：{{ scope.row.sendTime }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </li>
            <li class="mb20">
              <div class="title">操作信息</div>
              <el-table stripe border :data="orderStatus" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="operatorAccount"
                  label="操作账号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="operatorName"
                  label="操作人"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.operatorName === null">
                      {{ scope.row.createBy }}
                    </div>
                    <div v-else>
                      {{ scope.row.operatorName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="createTime"
                  label="操作时间"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="订单状态"
                >
                  <template slot-scope="scope">
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'createOrder'"
                      >待付款</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'payOrder'"
                      >待发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'deliverOrder'"
                      >已发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'takeOrder'"
                      >已收货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'pushOrder'"
                      >已评价</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'delOrder'"
                      >已取消</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'returnOrder'"
                      >有退货退款</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="付款状态"
                >
                  <template slot-scope="scope">
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'createOrder'"
                      >未付款</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'payOrder'"
                      >已付款</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'deliverOrder'"
                      >已付款</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'takeOrder'"
                      >已付款</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'pushOrder'"
                      >已付款</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'delOrder'"
                      >已取消</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="发货状态"
                >
                  <template slot-scope="scope">
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'createOrder'"
                      >未发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'payOrder'"
                      >未发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'deliverOrder'"
                      >已发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'takeOrder'"
                      >已发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'pushOrder'"
                      >已发货</span
                    >
                    <span
                      class="status blue"
                      v-if="scope.row.orderStatus === 'delOrder'"
                      >已取消</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="remark"
                  label="备注"
                ></el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button size="small" type="text" @click="beizhu(scope.row)"
                        >添加备注</el-button
                      >
                    </div>
                  </template>
                </el-table-column> -->
              </el-table>
            </li>
          </ul>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            @click="onlineDialogVisible = false"
            size="small"
            type="primary"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
  </hm-content>
</template>
<script>
import { mapState } from "vuex";
// import HmUserProfile from "../../components/HmUserProfile";
export default {
  components: {
    // HmUserProfile
  },
  data() {
    return {
      searchCondition: {},
      orderDetails: {},
      ruleFormRetrun: {
        returnType: "",
        returnDeliverMoney: "",
        returnContext: ""
      },
      orderGoods: [],
      orderStatus: [],
      position: 0,
      active: 2,
      orderSta: "",
      couponSendId: this.$route.query.couponSendId,
      couponRuleId: this.$route.query.couponRuleId,
      ruleName: this.$route.query.ruleName,
      isSendToGuider: this.$route.query.isSendToGuider,
      useReturnDeliverMoney: 0,
      dialogVisible: false,
      onlineDialogVisible: false,
      showCustomerDetail: false,
      offlineVipId: "",
      value: "",
      qrcodeUrl: "",
      currentRow: {},
      orderDetail: {},
      createOrderTime: "",
      payOrderTime: "",
      belongShopId: "",
      deliverOrderTime: "",
      takeOrderTime: "",
      pushOrderTime: "",
      couponInfo: [],
      btnList: [
        // { name: '全部', active: true, count: 0, status: '' },
        { name: "已领取", active: false, count: 0, status: 0, show: false },
        { name: "待领取", active: false, count: 0, status: 3, show: false },
        { name: "已使用", active: false, count: 0, status: 2, show: true },
        { name: "未使用", active: false, count: 0, status: 4, show: true },
        { name: "冻结", active: false, count: 0, status: 5, show: true }
      ],
      status: "",
      currentPage: 1,
      activeTab: 0,
      orderNum: "",
      isLoading: false,
      keywords: "",
      pageSize: 10
    };
  },
  created() {
    const { sendWayType } = this.$route.query;
    if (parseInt(sendWayType) === 2) {
      this.btnList[0].show = true;
      this.btnList[1].show = true;
      this.activeTab = this.btnList[0].status;
    } else {
      this.activeTab = this.btnList[2].status;
    }
    this.$store.dispatch("getDetail", {
      couponSendId: this.couponSendId,
      couponRuleId: this.couponRuleId,
      pageNo: this.currentPage,
      status: this.btnList[this.activeTab].status,
      userName: this.keywords,
      pageSize: this.pageSize
    });
  },
  computed: mapState({
    detailType: state => state.rules.detailType,
    detail: state => state.rules.detail,
    allDetail: state => state.rules.allDetail,
    detailTotal: state => state.rules.detailTotal,
    orders: state => state.rules.orders
  }),
  watch: {
    detailType(val) {
      this.btnList.forEach(v => {
         v.count = 0;
        val.forEach(item => {
          if (item.status === v.status) {
            v.count = item.num;
          }
        });
      });
    },
    allDetail(val) {
      if (val.length > 0) {
        this.isLoading = false;
        require.ensure([], () => {
          const {
            exportJsonToExcel
          } = require("../../utils/output/Export2Excel");
          const tHeader = [
            "导购名",
            "导购归属门店",
            "用户名",
            "手机号",
            "微信编码",
            "会员卡号",
            "券码",
            "使用订单",
            "券状态",
            "发放时间",
            "使用时间"
          ];
          const filterVal = [
            "guiderName",
            "storeOutletName",
            "memberName",
            "memberMobile",
            "userName",
            "offlineVipNo",
            "couponCode",
            "toOrder",
            "status",
            "createTimeFormat",
            "useDate"
          ];
          const list = val;
          const data = this.formatJson(filterVal, list);
          exportJsonToExcel(tHeader, data, "优惠券使用详情");
        });
      } else {
        this.isLoading = false;
        this.$message({
          message: "暂无可导出数据",
          type: "warning"
        });
      }
    }
  },
  methods: {
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.$store.dispatch("getDetail", {
        couponSendId: this.couponSendId,
        couponRuleId: this.couponRuleId,
        pageNo: this.currentPage,
        status: this.activeTab,
        keywords: this.keywords,
        pageSize: this.pageSize
      });
    },
    output() {
      this.isOutputing = true;
      let params = {
        couponSendId: this.couponSendId,
        couponRuleId: this.couponRuleId,
        pageNo: 1,
        status: this.activeTab,
        pageSize: 100000000,
        keywords: "",
      }
      const searchCondition = JSON.parse(JSON.stringify(params));
      searchCondition.exportName = "优惠券发放明细";
      this.$store.dispatch("getAllDetail", params);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.isOutputing = false;
      }, 0);

    },

    async queryAllList(){
      this.$store.dispatch("getAllDetail", {
        couponSendId: this.couponSendId,
        couponRuleId: this.couponRuleId,
        pageNo: 1,
        status: this.activeTab,
        pageSize: 100000000,
        keywords: ""
      });
      return code;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchTab(status) {
      this.activeTab = status;
      this.currentPage = 1;
      this.$store.dispatch("getDetail", {
        couponSendId: this.couponSendId,
        couponRuleId: this.couponRuleId,
        pageNo: this.currentPage,
        status,
        keywords: this.keywords,
        pageSize: this.pageSize
      });
    },
    async viewOrder(type, row) {
      if (type === "offline") {
        const { result } = await this.$store.dispatch(
          "queryOfflineOrderDetails",
          {
            orderId: row.toOrder,
            orderOfflineId: row.orderOfflineId
          }
        );
        const { couponInfo, orderDetail } = result;
        this.couponInfo = couponInfo;
        let totPrice = 0;
        orderDetail.map(v => {
          totPrice += v.shop_price * v.goods_number;
        });
        this.orderDetail = orderDetail;
        this.currentRow = row;
        this.currentRow.totPrice = totPrice;
        this.dialogVisible = true;
      } else {
        this.querydetails(row);
        this.onlineDialogVisible = true;
      }
    },

    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置
      if (columnIndex === 9) {
        const _row = this.rowSpanArr[rowIndex];

        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }
    },
    search() {
      let params = {
        couponSendId: this.couponSendId,
        couponRuleId: this.couponRuleId,
        pageNo: this.currentPage,
        status: this.activeTab,
        keywords: this.keywords,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      this.$store.dispatch("getDetail", params);
    },
    openUserProfile(offlineVipId) {
      this.offlineVipId = offlineVipId;
    },
    resetOfflineId() {
      this.offlineVipId = "";
    },
    paging(page) {
      this.currentPage = page;
      let params = {
        couponSendId: this.couponSendId,
        couponRuleId: this.couponRuleId,
        pageNo: this.currentPage,
        status: this.activeTab,
        keywords: this.keywords,
        pageSize: this.pageSize
      }
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      this.$store.dispatch("getDetail", params);
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    async querydetails(row) {
      const res = await this.$store.dispatch("queryOrderDetails", {
        orderId: row.orderOnlineId
      });
      this.orderDetails = res.result.order;
      this.orderGoods = [];
      res.result.orderGoods.forEach(v => {
        this.orderGoods.push(...v.goodsList);
      });
      this.orderStatus = res.result.orderStatus;
      let orderSta = res.result.orderStatus[res.result.orderStatus.length - 1];
      let flag = false;
      res.result.orderGoods.map(v => {
        if (v.returnType === "no") {
          flag = true;
        }
      });
      if (flag) {
        let listStatus = [];
        res.result.orderStatus.forEach(v => {
          if (v.orderStatus !== "returnOrder") {
            listStatus.push(v);
          }
        });
        orderSta = listStatus[listStatus.length - 1];
      }

      if (orderSta.orderStatus === "createOrder") {
        this.active = 1;
        this.delOrder = true;
        this.disabled = true;
        this.delivery = true;
        this.orderSta = "待付款";
      } else if (orderSta.orderStatus === "payOrder") {
        this.active = 2;
        this.delOrder = true;
        this.disabled = false;
        this.delivery = true;
        this.orderSta = "待发货";
      } else if (orderSta.orderStatus === "deliverOrder") {
        this.active = 3;
        this.delOrder = true;
        this.orderSta = "已发货";
        this.delivery = false;
        this.disabled = true;
      } else if (orderSta.orderStatus === "takeOrder") {
        this.active = 4;
        this.delOrder = true;
        this.orderSta = "已收货";
        this.delivery = true;
        this.disabled = true;
      } else if (orderSta.orderStatus === "pushOrder") {
        this.active = 5;
        this.delOrder = true;
        this.orderSta = "已评价";
        this.delivery = true;
        this.disabled = true;
      } else if (orderSta.orderStatus === "delOrder") {
        this.delOrder = false;
        this.orderSta = "已取消";
      } else if (orderSta.orderStatus === "returnOrder") {
        this.delOrder = false;
        this.orderSta = "有退货退款";
      }

      res.result.orderStatus.forEach(v => {
        if (v.orderStatus === "createOrder") {
          this.createOrderTime = v.createTime;
        }
        if (v.orderStatus === "payOrder") {
          this.payOrderTime = v.createTime;
        }
        if (v.orderStatus === "deliverOrder") {
          this.deliverOrderTime = v.createTime;
        }
        if (v.orderStatus === "takeOrder") {
          this.takeOrderTime = v.createTime;
        }
        if (v.orderStatus === "pushOrder") {
          this.pushOrderTime = v.createTime;
        }
      });
      let returnDeliver = 0;
      res.result.orderGoods.forEach(v => {
        returnDeliver += v.returnDeliverMoney || 0;
      });

      this.useReturnDeliverMoney = (
        res.result.order.deliverMoney -
        returnDeliver -
        res.result.order.deliverCouponMoney
      ).toFixed(2);
      this.ruleFormRetrun.returnDeliverMoney = this.useReturnDeliverMoney;
      this.getRowSpan();
    },

    getRowSpan() {
      this.rowSpanArr = [];
      this.orderGoods.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.orderGoods[index].expressQueryId ==
            this.orderGoods[index - 1].expressQueryId
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.orderGoods[index].expressQueryId = this.orderGoods[
              index - 1
            ].expressQueryId;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    sortChange(sort) {
      console.log("sort:",sort);
      Object.assign(this.searchCondition, sort);
      this.search();
    },
  }
};
</script>
<style lang="scss" scoped>
.btn {
  cursor: pointer;
  font-size: 0.875rem;
  color: #999;
  padding: 8px 20px;
  transition: background 0.1s linear;
}

.btn.active {
  background: #e50065;
  color: #fff;
  border-radius: 5px;
}

.btn.active:hover {
  background: #e50065;
  border-color: #e50065;
}
.table {
  padding: 10px 0;
}
.qrcode-wrapper {
  text-align: center;
  img {
    width: 200px;
    height: 200px;
  }
}
.table {
  padding: 10px 0;
}
.order-number {
  cursor: pointer;
  color: #4680ff;
}
.dialog-title {
  padding-left: 10px;
  border-left: 3px solid #4680ff;
}
.order-list {
  .item {
    padding: 0.5rem;
    border-bottom: 1px solid #ebeef5;
    .name {
      width: 50%;
    }
    .money {
      width: 30%;
      text-align: left;
    }
  }
}
</style>
